export const colors = {
    black: '#000',
    white: '#f9f9f9',
    gray: '#646464',
    lightGray: '#A7A7A7',

    background: '#000000',
    text: '#ffffff',
    cubeText: '#f9f9f9',

    bgLight: '#f7f7f7',
    bgDark: '#1e1e1e',
    secondary: '#c0c0c0',
    accent: '#A8E10C',
} as const
